import Eligibility from './Eligibility';

export default Eligibility;
